/**
 * postMessage-Protokoll zwischen Dashboard und Editier-iframe (Gegenstueck:
 * node-app/src/services/lpFunnel/editorRuntime.ts). Das iframe hat einen opaken Ursprung
 * (srcdoc + sandbox ohne allow-same-origin) — Ziel '*' ist darum unvermeidbar; es wird nie etwas
 * Geheimes gesendet. Annahme nur, wenn event.source === iframe.contentWindow.
 */

export type IframeNachricht =
  | { lpEdit: 1; typ: 'bereit'; locked: number }
  | { lpEdit: 1; typ: 'dirty'; dirty: boolean; undo: number }
  | { lpEdit: 1; typ: 'serialisiert'; reqId: string; html: string }
  | { lpEdit: 1; typ: 'bildErsetzen'; bildId: string }
  /** „Aus Produkt-Medien …" — die Eltern zeigen die Auswahl (ProduktBildDialog). */
  | { lpEdit: 1; typ: 'produktBildWahl'; bildId: string }
  | { lpEdit: 1; typ: 'meldung'; text: string; art: 'info' | 'warnung' }
  | { lpEdit: 1; typ: 'speichernWunsch' };

export type ElternNachricht =
  | { lpEdit: 1; typ: 'serialisieren'; reqId: string }
  | { lpEdit: 1; typ: 'bildUrl'; bildId: string; url: string }
  /** Bindung `fach:variante` (data-lp-produktbild) + aktuelle URL als src. */
  | { lpEdit: 1; typ: 'produktBild'; bildId: string; bindung: string; url: string }
  | { lpEdit: 1; typ: 'ansicht'; wert: string }
  | { lpEdit: 1; typ: 'rueckgaengig' };

const TYPEN = new Set([
  'bereit',
  'dirty',
  'serialisiert',
  'bildErsetzen',
  'produktBildWahl',
  'meldung',
  'speichernWunsch',
]);

export function istIframeNachricht(d: unknown): d is IframeNachricht {
  if (!d || typeof d !== 'object') return false;
  const m = d as { lpEdit?: unknown; typ?: unknown };
  return m.lpEdit === 1 && typeof m.typ === 'string' && TYPEN.has(m.typ);
}

export function sende(win: Window | null | undefined, m: ElternNachricht): void {
  // Opaker Ursprung: '*' ist die einzige moegliche Zielangabe. Inhalt: nur Seitenmarkup/URLs.
  win?.postMessage(m, '*');
}
